// source: messages/payments.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var messages_core_message_pb = require('../messages/core.message_pb.js');
goog.object.extend(proto, messages_core_message_pb);
goog.exportSymbol('proto.payments_messages.BillLineItem', null, global);
goog.exportSymbol('proto.payments_messages.CreateBillRequest', null, global);
goog.exportSymbol('proto.payments_messages.CreateBillResponse', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsBill', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsBillStatus', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetBillsForCaseRequest', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetBillsForCaseResponse', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetBillsForClaimRequest', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetBillsForClaimResponse', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetVendorRequest', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsGetVendorResponse', null, global);
goog.exportSymbol('proto.payments_messages.PaymentsVendor', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsVendor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsVendor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsVendor.displayName = 'proto.payments_messages.PaymentsVendor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsBill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsBill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsBill.displayName = 'proto.payments_messages.PaymentsBill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetVendorRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsGetVendorRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetVendorRequest.displayName = 'proto.payments_messages.PaymentsGetVendorRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetVendorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsGetVendorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetVendorResponse.displayName = 'proto.payments_messages.PaymentsGetVendorResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsGetBillsForCaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetBillsForCaseRequest.displayName = 'proto.payments_messages.PaymentsGetBillsForCaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.payments_messages.PaymentsGetBillsForCaseResponse.repeatedFields_, null);
};
goog.inherits(proto.payments_messages.PaymentsGetBillsForCaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetBillsForCaseResponse.displayName = 'proto.payments_messages.PaymentsGetBillsForCaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.PaymentsGetBillsForClaimRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetBillsForClaimRequest.displayName = 'proto.payments_messages.PaymentsGetBillsForClaimRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.payments_messages.PaymentsGetBillsForClaimResponse.repeatedFields_, null);
};
goog.inherits(proto.payments_messages.PaymentsGetBillsForClaimResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.PaymentsGetBillsForClaimResponse.displayName = 'proto.payments_messages.PaymentsGetBillsForClaimResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.CreateBillRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.payments_messages.CreateBillRequest.repeatedFields_, null);
};
goog.inherits(proto.payments_messages.CreateBillRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.CreateBillRequest.displayName = 'proto.payments_messages.CreateBillRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.BillLineItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.BillLineItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.BillLineItem.displayName = 'proto.payments_messages.BillLineItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.payments_messages.CreateBillResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.payments_messages.CreateBillResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.payments_messages.CreateBillResponse.displayName = 'proto.payments_messages.CreateBillResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsVendor.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsVendor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsVendor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsVendor.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
legalName: jspb.Message.getFieldWithDefault(msg, 3, ""),
entityTitle: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsVendor}
 */
proto.payments_messages.PaymentsVendor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsVendor;
  return proto.payments_messages.PaymentsVendor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsVendor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsVendor}
 */
proto.payments_messages.PaymentsVendor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntityTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsVendor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsVendor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsVendor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsVendor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLegalName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEntityTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.payments_messages.PaymentsVendor.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsVendor} returns this
 */
proto.payments_messages.PaymentsVendor.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.payments_messages.PaymentsVendor.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.PaymentsVendor} returns this
 */
proto.payments_messages.PaymentsVendor.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string legal_name = 3;
 * @return {string}
 */
proto.payments_messages.PaymentsVendor.prototype.getLegalName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.PaymentsVendor} returns this
 */
proto.payments_messages.PaymentsVendor.prototype.setLegalName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string entity_title = 4;
 * @return {string}
 */
proto.payments_messages.PaymentsVendor.prototype.getEntityTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.PaymentsVendor} returns this
 */
proto.payments_messages.PaymentsVendor.prototype.setEntityTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsBill.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsBill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsBill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsBill.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
caseId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
status: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
total: (f = msg.getTotal()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
memo: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
createdAt: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
paymentNumber: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
claimId: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsBill}
 */
proto.payments_messages.PaymentsBill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsBill;
  return proto.payments_messages.PaymentsBill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsBill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsBill}
 */
proto.payments_messages.PaymentsBill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    case 3:
      var value = /** @type {!proto.payments_messages.PaymentsBillStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentNumber(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setClaimId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsBill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsBill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsBill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsBill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {!proto.payments_messages.PaymentsBillStatus} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.payments_messages.PaymentsBill.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 case_id = 2;
 * @return {number}
 */
proto.payments_messages.PaymentsBill.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setCaseId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearCaseId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasCaseId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PaymentsBillStatus status = 3;
 * @return {!proto.payments_messages.PaymentsBillStatus}
 */
proto.payments_messages.PaymentsBill.prototype.getStatus = function() {
  return /** @type {!proto.payments_messages.PaymentsBillStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.payments_messages.PaymentsBillStatus} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional core_messages.Decimal total = 4;
 * @return {?proto.core_messages.Decimal}
 */
proto.payments_messages.PaymentsBill.prototype.getTotal = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 4));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
*/
proto.payments_messages.PaymentsBill.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string memo = 5;
 * @return {string}
 */
proto.payments_messages.PaymentsBill.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setMemo = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearMemo = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasMemo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.payments_messages.PaymentsBill.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setCreatedAt = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearCreatedAt = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string payment_number = 7;
 * @return {string}
 */
proto.payments_messages.PaymentsBill.prototype.getPaymentNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setPaymentNumber = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearPaymentNumber = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasPaymentNumber = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 claim_id = 8;
 * @return {number}
 */
proto.payments_messages.PaymentsBill.prototype.getClaimId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.setClaimId = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.payments_messages.PaymentsBill} returns this
 */
proto.payments_messages.PaymentsBill.prototype.clearClaimId = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsBill.prototype.hasClaimId = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetVendorRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetVendorRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetVendorRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetVendorRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetVendorRequest}
 */
proto.payments_messages.PaymentsGetVendorRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetVendorRequest;
  return proto.payments_messages.PaymentsGetVendorRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetVendorRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetVendorRequest}
 */
proto.payments_messages.PaymentsGetVendorRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetVendorRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetVendorRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetVendorRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetVendorRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.payments_messages.PaymentsGetVendorRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsGetVendorRequest} returns this
 */
proto.payments_messages.PaymentsGetVendorRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetVendorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetVendorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetVendorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetVendorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
vendor: (f = msg.getVendor()) && proto.payments_messages.PaymentsVendor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetVendorResponse}
 */
proto.payments_messages.PaymentsGetVendorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetVendorResponse;
  return proto.payments_messages.PaymentsGetVendorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetVendorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetVendorResponse}
 */
proto.payments_messages.PaymentsGetVendorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.payments_messages.PaymentsVendor;
      reader.readMessage(value,proto.payments_messages.PaymentsVendor.deserializeBinaryFromReader);
      msg.setVendor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetVendorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetVendorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetVendorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetVendorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVendor();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.payments_messages.PaymentsVendor.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentsVendor vendor = 1;
 * @return {?proto.payments_messages.PaymentsVendor}
 */
proto.payments_messages.PaymentsGetVendorResponse.prototype.getVendor = function() {
  return /** @type{?proto.payments_messages.PaymentsVendor} */ (
    jspb.Message.getWrapperField(this, proto.payments_messages.PaymentsVendor, 1));
};


/**
 * @param {?proto.payments_messages.PaymentsVendor|undefined} value
 * @return {!proto.payments_messages.PaymentsGetVendorResponse} returns this
*/
proto.payments_messages.PaymentsGetVendorResponse.prototype.setVendor = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.payments_messages.PaymentsGetVendorResponse} returns this
 */
proto.payments_messages.PaymentsGetVendorResponse.prototype.clearVendor = function() {
  return this.setVendor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.PaymentsGetVendorResponse.prototype.hasVendor = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetBillsForCaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseRequest}
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetBillsForCaseRequest;
  return proto.payments_messages.PaymentsGetBillsForCaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseRequest}
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetBillsForCaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseRequest} returns this
 */
proto.payments_messages.PaymentsGetBillsForCaseRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetBillsForCaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billList: jspb.Message.toObjectList(msg.getBillList(),
    proto.payments_messages.PaymentsBill.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseResponse}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetBillsForCaseResponse;
  return proto.payments_messages.PaymentsGetBillsForCaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseResponse}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.payments_messages.PaymentsBill;
      reader.readMessage(value,proto.payments_messages.PaymentsBill.deserializeBinaryFromReader);
      msg.addBill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetBillsForCaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetBillsForCaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.payments_messages.PaymentsBill.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PaymentsBill bill = 1;
 * @return {!Array<!proto.payments_messages.PaymentsBill>}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.getBillList = function() {
  return /** @type{!Array<!proto.payments_messages.PaymentsBill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.payments_messages.PaymentsBill, 1));
};


/**
 * @param {!Array<!proto.payments_messages.PaymentsBill>} value
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseResponse} returns this
*/
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.setBillList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.payments_messages.PaymentsBill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.payments_messages.PaymentsBill}
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.addBill = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.payments_messages.PaymentsBill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.payments_messages.PaymentsGetBillsForCaseResponse} returns this
 */
proto.payments_messages.PaymentsGetBillsForCaseResponse.prototype.clearBillList = function() {
  return this.setBillList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetBillsForClaimRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimRequest}
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetBillsForClaimRequest;
  return proto.payments_messages.PaymentsGetBillsForClaimRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimRequest}
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetBillsForClaimRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimRequest} returns this
 */
proto.payments_messages.PaymentsGetBillsForClaimRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.PaymentsGetBillsForClaimResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billList: jspb.Message.toObjectList(msg.getBillList(),
    proto.payments_messages.PaymentsBill.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimResponse}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.PaymentsGetBillsForClaimResponse;
  return proto.payments_messages.PaymentsGetBillsForClaimResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimResponse}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.payments_messages.PaymentsBill;
      reader.readMessage(value,proto.payments_messages.PaymentsBill.deserializeBinaryFromReader);
      msg.addBill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.PaymentsGetBillsForClaimResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.PaymentsGetBillsForClaimResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.payments_messages.PaymentsBill.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PaymentsBill bill = 1;
 * @return {!Array<!proto.payments_messages.PaymentsBill>}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.getBillList = function() {
  return /** @type{!Array<!proto.payments_messages.PaymentsBill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.payments_messages.PaymentsBill, 1));
};


/**
 * @param {!Array<!proto.payments_messages.PaymentsBill>} value
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimResponse} returns this
*/
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.setBillList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.payments_messages.PaymentsBill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.payments_messages.PaymentsBill}
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.addBill = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.payments_messages.PaymentsBill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.payments_messages.PaymentsGetBillsForClaimResponse} returns this
 */
proto.payments_messages.PaymentsGetBillsForClaimResponse.prototype.clearBillList = function() {
  return this.setBillList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.payments_messages.CreateBillRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.CreateBillRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.CreateBillRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.CreateBillRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.CreateBillRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
caseId: jspb.Message.getFieldWithDefault(msg, 1, 0),
vendorId: jspb.Message.getFieldWithDefault(msg, 2, 0),
memo: jspb.Message.getFieldWithDefault(msg, 3, ""),
useSandbox: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
totalAmount: (f = msg.getTotalAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
lineItemsList: jspb.Message.toObjectList(msg.getLineItemsList(),
    proto.payments_messages.BillLineItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.CreateBillRequest}
 */
proto.payments_messages.CreateBillRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.CreateBillRequest;
  return proto.payments_messages.CreateBillRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.CreateBillRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.CreateBillRequest}
 */
proto.payments_messages.CreateBillRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVendorId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseSandbox(value);
      break;
    case 5:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setTotalAmount(value);
      break;
    case 6:
      var value = new proto.payments_messages.BillLineItem;
      reader.readMessage(value,proto.payments_messages.BillLineItem.deserializeBinaryFromReader);
      msg.addLineItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.CreateBillRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.CreateBillRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.CreateBillRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.CreateBillRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVendorId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUseSandbox();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTotalAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getLineItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.payments_messages.BillLineItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 case_id = 1;
 * @return {number}
 */
proto.payments_messages.CreateBillRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 vendor_id = 2;
 * @return {number}
 */
proto.payments_messages.CreateBillRequest.prototype.getVendorId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string memo = 3;
 * @return {string}
 */
proto.payments_messages.CreateBillRequest.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool use_sandbox = 4;
 * @return {boolean}
 */
proto.payments_messages.CreateBillRequest.prototype.getUseSandbox = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.setUseSandbox = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional core_messages.Decimal total_amount = 5;
 * @return {?proto.core_messages.Decimal}
 */
proto.payments_messages.CreateBillRequest.prototype.getTotalAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 5));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
*/
proto.payments_messages.CreateBillRequest.prototype.setTotalAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.clearTotalAmount = function() {
  return this.setTotalAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.CreateBillRequest.prototype.hasTotalAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated BillLineItem line_items = 6;
 * @return {!Array<!proto.payments_messages.BillLineItem>}
 */
proto.payments_messages.CreateBillRequest.prototype.getLineItemsList = function() {
  return /** @type{!Array<!proto.payments_messages.BillLineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.payments_messages.BillLineItem, 6));
};


/**
 * @param {!Array<!proto.payments_messages.BillLineItem>} value
 * @return {!proto.payments_messages.CreateBillRequest} returns this
*/
proto.payments_messages.CreateBillRequest.prototype.setLineItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.payments_messages.BillLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.payments_messages.BillLineItem}
 */
proto.payments_messages.CreateBillRequest.prototype.addLineItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.payments_messages.BillLineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.payments_messages.CreateBillRequest} returns this
 */
proto.payments_messages.CreateBillRequest.prototype.clearLineItemsList = function() {
  return this.setLineItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.BillLineItem.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.BillLineItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.BillLineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.BillLineItem.toObject = function(includeInstance, msg) {
  var f, obj = {
description: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: (f = msg.getAmount()) && messages_core_message_pb.Decimal.toObject(includeInstance, f),
legalBenefitId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.BillLineItem}
 */
proto.payments_messages.BillLineItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.BillLineItem;
  return proto.payments_messages.BillLineItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.BillLineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.BillLineItem}
 */
proto.payments_messages.BillLineItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = new messages_core_message_pb.Decimal;
      reader.readMessage(value,messages_core_message_pb.Decimal.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegalBenefitId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.BillLineItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.BillLineItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.BillLineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.BillLineItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getLegalBenefitId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.payments_messages.BillLineItem.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.BillLineItem} returns this
 */
proto.payments_messages.BillLineItem.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional core_messages.Decimal amount = 2;
 * @return {?proto.core_messages.Decimal}
 */
proto.payments_messages.BillLineItem.prototype.getAmount = function() {
  return /** @type{?proto.core_messages.Decimal} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.Decimal, 2));
};


/**
 * @param {?proto.core_messages.Decimal|undefined} value
 * @return {!proto.payments_messages.BillLineItem} returns this
*/
proto.payments_messages.BillLineItem.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.payments_messages.BillLineItem} returns this
 */
proto.payments_messages.BillLineItem.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.payments_messages.BillLineItem.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 legal_benefit_id = 3;
 * @return {number}
 */
proto.payments_messages.BillLineItem.prototype.getLegalBenefitId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.payments_messages.BillLineItem} returns this
 */
proto.payments_messages.BillLineItem.prototype.setLegalBenefitId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.payments_messages.CreateBillResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.payments_messages.CreateBillResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payments_messages.CreateBillResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.CreateBillResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
billId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payments_messages.CreateBillResponse}
 */
proto.payments_messages.CreateBillResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.payments_messages.CreateBillResponse;
  return proto.payments_messages.CreateBillResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payments_messages.CreateBillResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payments_messages.CreateBillResponse}
 */
proto.payments_messages.CreateBillResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.payments_messages.CreateBillResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.payments_messages.CreateBillResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payments_messages.CreateBillResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.payments_messages.CreateBillResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string bill_id = 1;
 * @return {string}
 */
proto.payments_messages.CreateBillResponse.prototype.getBillId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.payments_messages.CreateBillResponse} returns this
 */
proto.payments_messages.CreateBillResponse.prototype.setBillId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.payments_messages.PaymentsBillStatus = {
  PAYMENTS_STATUS_OPEN: 0,
  PAYMENTS_STATUS_PAID_IN_FULL: 1,
  PAYMENTS_STATUS_CANCELLED: 2,
  PAYMENTS_STATUS_REJECTED: 3
};

goog.object.extend(exports, proto.payments_messages);
